import React from "react";

import Hr from "../../UI/Hr";

import "./styles.scss";

const QuestionnaireLayout = (props) => {
  const { children, headerRightContent, heading } = props;

  return (
    <div className="container">
      <div className="QuestionnaireLayout px-3 mx-auto">
        <div className="d-flex justify-content-between">
          <h1 className="QuestionnaireLayout__heading fs-16 m-0 px-0 px-lg-3 tw:font-bold">
            {heading}
          </h1>
          {headerRightContent && (
            <h1
              className="QuestionnaireLayout__heading fs-16 m-0 px-0 px-lg-3 tw:font-bold"
              data-private
            >
              {headerRightContent}
            </h1>
          )}
        </div>
        <Hr className="" />
        {/* `props.children` */}
        {children}
      </div>
    </div>
  );
};

export default QuestionnaireLayout;
